// packages/main/app/web/components-v2/UnifiedImageDialog/styles.ts
import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

export const s = StyleSheet.create({
	tabTriggerFreeImages: {
		width: '100%',
		whiteSpace: 'nowrap',
	},
	dialogContent: {
		maxWidth: '90vw',
		maxHeight: '90vh',
		width: '1200px',
		height: '700px',
		display: 'flex',
		flexDirection: 'column',
		padding: 0,
	},
	dialogHeader: {
		padding: `${THEME.spacing.lg}px ${THEME.spacing.lg}px ${THEME.spacing.md}px`,
	},
	dialogBody: {
		display: 'flex',
		flex: 1,
		overflow: 'hidden',
		padding: 0,
	},
	tabsContainer: {
		display: 'flex',
		flex: 1,
		overflow: 'hidden',
	},
	verticalTabList: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		padding: THEME.spacing.md,
		borderRight: `1px solid ${THEME.colors.border.light}`,
		width: '180px',
		maxWidth: '20%',
		flexShrink: 0,
		// Target tab trigger buttons within this list
		':global(button)': {
			display: 'flex',
			alignItems: 'center',
			gap: THEME.spacing.md,
			padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
			border: 'none',
			borderRadius: THEME.common.borderRadius,
			backgroundColor: 'transparent',
			color: THEME.colors.text.main,
			fontSize: THEME.typography.fontSizes.sm,
			fontWeight: THEME.typography.fontWeights.standard,
			cursor: 'pointer',
			transition: 'all 0.2s',
			textAlign: 'left',
			width: '100%',
		},
		':global(button:hover)': {
			backgroundColor: THEME.colors.hover.light,
		},
		':global(button[data-state="active"])': {
			backgroundColor: THEME.colors.primary.light,
			color: THEME.colors.primary.main,
		},
		// Target tab icons to ensure consistent sizing and alignment
		':global(.tab-icon)': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			flexShrink: 0,
			color: 'inherit', // Inherit color from button
			lineHeight: 1, // Remove line-height to prevent vertical offset
		},
		':global(.tab-icon svg)': {
			display: 'block', // Remove inline spacing
			color: 'inherit', // Ensure SVG inherits color
		},
	},
	tabTrigger: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		border: 'none',
		borderRadius: THEME.common.borderRadius,
		backgroundColor: 'transparent',
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.standard,
		cursor: 'pointer',
		transition: 'all 0.2s',
		textAlign: 'left',
		':hover': {
			backgroundColor: THEME.colors.hover.light,
		},
		'[data-selected]': {
			backgroundColor: THEME.colors.primary.light,
			color: THEME.colors.primary.main,
		},
	},
	tabContent: {
		flex: 1,
		overflow: 'auto',
		padding: `${THEME.spacing.lg}px`,
	},
	tabIcon: {
		width: '20px',
		height: '20px',
	},
	tabContentWrapper: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
	},
	uploadContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.lg,
		height: '100%',
	},
	dropzone: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		border: `2px dashed ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		padding: THEME.spacing.xl,
		cursor: 'pointer',
		transition: 'all 0.2s',
		':hover': {
			borderColor: THEME.colors.primary.main,
			backgroundColor: THEME.colors.primary.light,
		},
		'[data-drag-active]': {
			borderColor: THEME.colors.primary.main,
			backgroundColor: THEME.colors.hover.light,
		},
	},
	dropzoneContent: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: THEME.spacing.md,
		textAlign: 'center',
	},
	dropzoneIcon: {
		width: 64,
		height: 64,
		color: THEME.colors.icon.gray,
	},
	dropzoneTitle: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
	},
	dropzoneDescription: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
	fileInput: {
		display: 'none',
	},
	errorMessage: {
		padding: THEME.spacing.sm,
		backgroundColor: THEME.colors.danger.light,
		color: THEME.colors.danger.dark,
		borderRadius: THEME.common.borderRadius,
		fontSize: THEME.typography.fontSizes.sm,
	},
	chatContainer: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		gap: THEME.spacing.md,
	},
	chatMessages: {
		flex: 1,
		overflow: 'auto',
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	chatInputContainer: {
		borderTop: `1px solid ${THEME.colors.border.light}`,
		paddingTop: THEME.spacing.md,
	},
	previewSection: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
	previewImageContainer: {
		flex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: THEME.spacing.xl,
		backgroundColor: THEME.colors.background.light,
	},
	previewImage: {
		maxWidth: '100%',
		maxHeight: '100%',
		objectFit: 'contain',
		borderRadius: THEME.common.borderRadius,
	},
	previewActions: {
		display: 'flex',
		gap: THEME.spacing.md,
		padding: THEME.spacing.lg,
		borderTop: `1px solid ${THEME.colors.border.light}`,
		justifyContent: 'flex-end',
	},
});
